import { mount } from './mount';

const host = document.getElementById('game');
if (!host) throw new Error('Missing #game host element');

mount(host).catch(async (err) => {
  console.error('Failed to boot Fronterra web sandbox:', err);
  /*
   * ⭐ L4.D (d) — THE ONE WAY THE LOADING SCREEN COULD MAKE THINGS WORSE.
   *
   * Before the plate existed, a `mount()` that threw left the player looking at a dark rectangle
   * and a console error. With a plate up it would leave them looking at "Getting things ready"
   * forever — a screen promising something that is never coming, which is strictly worse than the
   * rectangle. So the catch arm drives the surface into its stuck state: one sentence, one Try
   * again button, focus on it.
   *
   * The handle is a local of the `mount()` call that just rejected, so it cannot be passed out;
   * `blockLoadingScreen()` reads the module-level singleton instead and is a no-op when no plate
   * was ever created. The dynamic import is the same chunk mount already fetched, so this costs a
   * resolved promise and no network.
   */
  try {
    (await import('../ui/loading/loading')).blockLoadingScreen();
  } catch {
    /* rule 6: a failed boot must never fail twice */
  }
});
